import React, { useContext, FunctionComponent } from 'react';

import { Asset, LinkObject } from '@api/v4/assets/assetTypes';
import { FlattenedAttachment } from '../EditTabTypes';
import assetModalContext from '../asset_modal_context';
import AttachmentImage from './attachmentImage';
import AttachmentList from './attachmentList';
import AttachmentUploader from './attachmentUploader';

interface AttachmentListContainerScopedContext {
  state: {
    initialData: {
      asset: Asset;
      assetKey: string;
      attachments: FlattenedAttachment[];
    };
    editState: {
      assetName: string;
      attachments: FlattenedAttachment[];
      thumbnailOverride: LinkObject;
      thumbnailUrl: string;
      watermark: LinkObject;
    };
  };
}

const AttachmentListContainer: FunctionComponent<{ isTask?: boolean; }> = ({
  isTask
}) => {
  const { state }: AttachmentListContainerScopedContext = useContext(assetModalContext);
  const { assetName, attachments, thumbnailOverride, thumbnailUrl } = state.editState;

  return (
    <>
      <AttachmentImage
        assetKey={state.initialData.assetKey}
        assetName={assetName}
        attachmentCount={attachments.length}
        attachmentExtension={state.initialData.asset ? state.initialData.asset.extension : ''}
        isTask={isTask}
        src={thumbnailOverride?.url || thumbnailUrl}
      />
      <div className="attachment-list-title">
        <span className="bff-paperclip" />
        <h4 className="attachment-list-count">{attachments.length}</h4>
        <h4>{attachments.length !== 1 ? bfTranslate('Attachments') : bfTranslate('Attachment')}</h4>
      </div>
      <AttachmentList />
      <AttachmentUploader />
    </>
  );
};

export default AttachmentListContainer;
